// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container-wide {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1920px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
@media (min-width: 768px) {

  .container-wide {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}
@media (min-width: 1236px) {

  .container-wide {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}
.container-lg {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1680px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
@media (min-width: 768px) {

  .container-lg {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}
@media (min-width: 1236px) {

  .container-lg {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}
.container-md {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1280px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
@media (min-width: 768px) {

  .container-md {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}
@media (min-width: 1236px) {

  .container-md {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}
.container-web {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1280px;
  padding-left: 0px;
  padding-right: 0px;
}
@media (min-width: 768px) {

  .container-web {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}
@media (min-width: 1236px) {

  .container-web {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}

.container-sm {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 980px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

@media (min-width: 768px) {

  .container-sm {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}

@media (min-width: 1236px) {

  .container-sm {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}
.top-middle {
  top: 50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.left-middle {
  left: 50%;
  --tw-translate-x: -50%;
  transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.gtranslate {
  position: relative;
  display: block;
  height: 100%;
}

@media (min-width: 768px) {

  .gtranslate {
    width: 160px;
  }
}

.common_id {
  display: flex;
  gap: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 768px) {

  .common_id {
    gap: 0.75rem;
  }
}

@media (min-width: 1236px) {

  .common_id {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
.common_id_image {
  height: 40px;
  width: auto;
}
@media (min-width: 768px) {

  .common_id_image {
    height: 50px;
  }
}
.common_id_contents {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-top: 3px;
}
.common_id_name {
  white-space: nowrap;
  font-size: 20px;
  font-weight: 700;
  line-height: 1em;
}
@media (min-width: 768px) {

  .common_id_name {
    font-size: 24px;
  }
}
.common_id_seminar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.common_id_seminar_text {
  white-space: nowrap;
  font-size: 11px;
  font-weight: 700;
  line-height: 1em;
}
@media (min-width: 768px) {

  .common_id_seminar_text {
    font-size: 14px;
  }
}
.common_id_seminar_logo {
  width: 21px;
}

.page_logo {
  display: inline-block;
  align-items: center;
}
.page_logo_frame {
  position: absolute;
  left: 0px;
  top: 0px;
  display: block;
  height: 100%;
  width: 100%;
}
.page_logo_image {
  width: 46px;
}
.page_logo_contents {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
  font-weight: 700;
}
.page_logo_name {
  font-size: 16px;
  line-height: 1em;
}
.page_logo_note {
  font-size: 12px;
  line-height: 1em;
  letter-spacing: 0.05em;
}

.topbar {
  display: flex;
  height: 35px;
  align-items: center;
  justify-content: space-between;
}

.topbar_contents {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  padding-right: 120px !important;
  font-size: 11px;
  font-weight: 700;
}

@media (min-width: 480px) {

  .topbar_contents {
    font-size: 0.8rem;
  }
}

@media (min-width: 1236px) {

  .topbar_contents {
    font-size: 0.86rem;
  }
}

.subtitle {
  position: relative;
  border-radius: 0.125rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 1.24rem;
  font-weight: 700;
}

@media (min-width: 1236px) {

  .subtitle {
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    font-size: 1.4rem;
  }
}
.subtitle_icon {
  position: absolute;
  display: block;
  height: 1em;
  width: 6px;
  top: 50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.subtitle_label {
  padding-left: 1rem;
}
@media (min-width: 1236px) {

  .subtitle_label {
    padding-left: 1.5rem;
  }
}

.checkbox_menu_button {
  display: flex;
  width: 100%;
  align-items: center;
  border-radius: 0.125rem;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: left;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.checkbox_menu_button_icon {
  margin-left: auto;
  --tw-text-opacity: 1;
  color: rgba(241, 24, 71, 1);
  color: rgba(241, 24, 71, var(--tw-text-opacity));
}

.checkbox_menu_submit {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 0.75rem;
  border-top-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(241, 245, 249, 1);
  border-color: rgba(241, 245, 249, var(--tw-border-opacity));
  padding: 1rem;
  padding-top: 1rem;
}

@media (min-width: 768px) {

  .checkbox_menu_submit {
    flex-direction: row;
  }
}
.checkbox_menu_submit_item {
  display: inline-flex;
  min-width: 5em;
  align-items: center;
  justify-content: center;
  border-radius: 0.125rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  text-align: center;
  font-size: 0.86rem;
  font-weight: 700;
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 500ms;
}

.checkbox_menu_reset {
  --tw-bg-opacity: 1;
  background-color: rgba(226, 232, 240, 1);
  background-color: rgba(226, 232, 240, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

.checkbox_menu_reset:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(203, 213, 225, 1);
  background-color: rgba(203, 213, 225, var(--tw-bg-opacity));
}

.checkbox_menu_return {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(0, 152, 234, 1);
  border-color: rgba(0, 152, 234, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 152, 234, 1);
  color: rgba(0, 152, 234, var(--tw-text-opacity));
}

.checkbox_menu_return:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 152, 234, 1);
  background-color: rgba(0, 152, 234, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.input_search {
  display: block;
  flex: 1 1 0%;
  border-width: 0px;
  background-color: transparent;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 1.0rem;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

@media (min-width: 480px) {

  .input_search {
    line-height: 1.5rem;
  }
}

.accordion_inner {
  overflow: hidden;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(226, 232, 240, 1);
  border-color: rgba(226, 232, 240, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.accordion_title {
  display: flex;
  width: 100%;
  align-items: center;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  padding-right: 4rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.accordion_title_badge {
  width: 2.0em;
  flex-shrink: 0;
  text-align: center;
  font-size: 1.5em;
  --tw-text-opacity: 1;
  color: rgba(26, 119, 197, 1);
  color: rgba(26, 119, 197, var(--tw-text-opacity));
}

@media (min-width: 768px) {

  .accordion_title_badge {
    width: 2.8em;
    font-size: 2em;
  }

  .accordion_title_label {
    font-size: 1.24rem;
  }
}

.accordion_content {
  --tw-bg-opacity: 1;
  background-color: rgba(244, 243, 238, 1);
  background-color: rgba(244, 243, 238, var(--tw-bg-opacity));
}

.accordion_content_inner {
  display: flex;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  padding-right: 1rem;
}

@media (min-width: 976px) {

  .accordion_content_inner {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
}

.accordion_content_badge {
  width: 2.0em;
  flex-shrink: 0;
  text-align: center;
  font-size: 1.5em;
  --tw-text-opacity: 1;
  color: rgba(239, 68, 68, 1);
  color: rgba(239, 68, 68, var(--tw-text-opacity));
}

@media (min-width: 768px) {

  .accordion_content_badge {
    width: 2.8em;
    font-size: 2em;
  }
}

.accordion_content_text {
  padding-top: 0.45rem;
}

@media (min-width: 768px) {

  .accordion_content_text {
    padding-top: 0.625rem;
    font-size: 1.15rem;
    line-height: 2rem;
  }
}

.table dl {
  display: flex;
  flex-direction: column;
}

@media (min-width: 976px) {

  .table dl {
    flex-direction: row;
  }
}
.table dt {
  width: 100%;
  flex-shrink: 0;
  padding: 1.5rem;
  padding-top: 1.5rem;
}
@media (min-width: 976px) {

  .table dt {
    width: 14em;
    padding-bottom: 1.5rem;
  }
}
.table dd {
  width: 100%;
  flex-grow: 1;
  align-self: center;
  padding: 1.5rem;
}

.page_bread {
  display: flex;
  flex-wrap: wrap;
}

.common_page_nav {
  position: relative;
  min-height: 120px;
  border-top-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(0, 152, 234, 1);
  border-color: rgba(0, 152, 234, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(7, 53, 137, 1);
  background-color: rgba(7, 53, 137, var(--tw-bg-opacity));
  padding: 2.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

@media (min-width: 1236px) {

  .common_page_nav {
    min-height: 160px;
    padding: 4rem;
  }
}

.common_page_eng {
  position: absolute;
  bottom: -18px;
  z-index: 20;
  font-size: 10em;
  line-height: .75rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  opacity: 0.1;
  mix-blend-mode: screen;
  left: 50%;
  --tw-translate-x: -50%;
  transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@media (min-width: 1236px) {

  .common_page_eng {
    font-size: 17em;
  }
}

.menu_label {
  display: flex;
  align-items: center;
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

@media (min-width: 1680px) {

  .menu_label {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.menu_label.navigation_current {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(224, 242, 254, 1) !important;
  background-color: rgba(224, 242, 254, var(--tw-bg-opacity)) !important;
}

.navigation_label {
  display: block;
  cursor: pointer;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  padding-left: 0.8vw;
  padding-right: 0.8vw;
  padding-top: 1rem;
  padding-bottom: 1rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.navigation_label:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(241, 245, 249, 1);
  background-color: rgba(241, 245, 249, var(--tw-bg-opacity));
}

@media (min-width: 1680px) {

  .navigation_label {
    padding-left: 1.8vw;
    padding-right: 1.8vw;
  }
}

.navigation_label.navigation_current {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(224, 242, 254, 1) !important;
  background-color: rgba(224, 242, 254, var(--tw-bg-opacity)) !important;
}

.navigation_underline {
  position: absolute;
  bottom: 0px;
  left: 0px;
  display: block;
  height: 4px;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgba(203, 213, 225, 1);
  background-color: rgba(203, 213, 225, var(--tw-bg-opacity));
  opacity: 0.5;
}

/* .navigation_default.navigation_current {
  @apply text-primary-gray-light;
} */

.navigation_button {
  display: flex;
  height: 60px;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 0.125rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  text-align: center;
  font-size: 0.86rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(26, 119, 197, 1);
  color: rgba(26, 119, 197, var(--tw-text-opacity));
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.navigation_button:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(226, 232, 240, 1);
  background-color: rgba(226, 232, 240, var(--tw-bg-opacity));
}

.item_button {
  display: inline-block;
  border-radius: 9999px;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.8rem;
  font-weight: 700;
  transition-duration: 300ms;
}

@media (min-width: 768px) {

  .item_button {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}

.item_button_md {
  display: inline-block;
  width: 100%;
  border-radius: 0.125rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
  font-size: 0.86rem;
  font-weight: 700;
  transition-duration: 300ms;
}

@media (min-width: 768px) {

  .item_button_md {
    width: auto;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
}

.item_button_base {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.125rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 700;
}

.seminar_item {
  display: block;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  transition-duration: 300ms;
}

.seminar_item:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(241, 245, 249, 1);
  background-color: rgba(241, 245, 249, var(--tw-bg-opacity));
}

@media (min-width: 768px) {

  .seminar_item {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

.seminar_item__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

@media (min-width: 768px) {

  .seminar_item__inner {
    flex-wrap: nowrap;
  }
}

.seminar_item__aside {
  display: flex;
  width: 100%;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding-bottom: 1rem;
}

@media (min-width: 768px) {

  .seminar_item__aside {
    width: 190px;
    padding-bottom: 0px;
    padding-right: 2.5rem;
  }
}

.seminar_item__main {
  flex-shrink: 1;
  flex-grow: 1;
  cursor: pointer;
}

.seminar_item__date_list {
  margin-right: auto;
  display: flex;
}

@media (min-width: 768px) {

  .seminar_item__date_list {
    width: 100%;
    flex-direction: column;
  }
}

.seminar_item__badge_list {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}

@media (min-width: 768px) {

  .seminar_item__badge_list {
    width: 100%;
    flex-direction: column;
  }
}

.seminar_item__badge_item {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.125rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  text-align: center;
  font-size: 0.86rem;
  font-weight: 700;
}

.seminar_item__category_list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

@media (min-width: 768px) {

  .seminar_item__category_list {
    order: 3;
  }
}

.seminar_item__category_item {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(0, 152, 234, 1);
  border-color: rgba(0, 152, 234, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 152, 234, 1);
  color: rgba(0, 152, 234, var(--tw-text-opacity));
}

.seminar_item__category_item:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 152, 234, 1);
  background-color: rgba(0, 152, 234, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.seminar_item__type_list {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

@media (min-width: 480px) {

  .seminar_item__type_list {
    flex-direction: row;
  }
}

@media (min-width: 768px) {

  .seminar_item__type_list {
    order: 1;
    margin-top: 0px;
  }
}

.common_banner__item {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgba(245, 249, 255, 1);
  background-color: rgba(245, 249, 255, var(--tw-bg-opacity));
}

@media (min-width: 768px) {

  .common_banner__item {
    flex-direction: row;
  }
}

.common_banner__icon {
  position: absolute;
  right: 1.75rem;
  top: 2rem;
  display: flex;
  height: 32px;
  width: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgba(26, 119, 197, 1);
  background-color: rgba(26, 119, 197, var(--tw-bg-opacity));
  font-size: 10px;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.link_text {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

@media (min-width: 768px) {

  .link_text {
    flex-direction: row;
    justify-content: flex-start;
  }
}

@media (min-width: 1236px) {

  .link_text {
    padding: 0px;
  }
}

.link_text__icon {
  display: flex;
  height: 1rem;
  width: 1rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, 1);
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.index_banner {
  display: grid;
  grid-gap: 1rem;
  gap: 1rem;
}

@media (min-width: 976px) {

  .index_banner {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1236px) {

  .index_banner {
    height: 430px;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
}

.index_banner__item {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgba(7, 53, 137, 1);
  background-color: rgba(7, 53, 137, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.index_banner__item:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(26, 119, 197, 1);
  background-color: rgba(26, 119, 197, var(--tw-bg-opacity));
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.index_banner__image {
  position: absolute;
  left: 0px;
  bottom: 0px;
  display: block;
  height: 100%;
  width: 100%;
  opacity: 0.7;
}

.index_banner__label {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  font-weight: 700;
}

@media (min-width: 976px) {

  .index_banner__label {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
}

@media (min-width: 1236px) {

  .index_banner__label {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
}

.index_banner__icon {
  position: absolute;
  right: 1.5rem;
  display: flex;
  height: 30px;
  width: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  font-size: 11px;
  --tw-text-opacity: 1;
  color: rgba(0, 152, 234, 1);
  color: rgba(0, 152, 234, var(--tw-text-opacity));
  top: 50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.index_intro__item {
  position: relative;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgba(26, 119, 197, 1);
  background-color: rgba(26, 119, 197, var(--tw-bg-opacity));
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.index_intro__item:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(7, 53, 137, 1);
  background-color: rgba(7, 53, 137, var(--tw-bg-opacity));
}

@media (min-width: 480px) {

  .index_intro__item {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
}

.index_intro__badge {
  position: absolute;
  top: 0px;
  z-index: 10;
  --tw-translate-y: -50%;
  border-radius: 0.125rem;
  --tw-bg-opacity: 1;
  background-color: rgba(26, 119, 197, 1);
  background-color: rgba(26, 119, 197, var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 12px;
  font-weight: 700;
  line-height: 2rem;
  letter-spacing: 0.025em;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  left: 50%;
  --tw-translate-x: -50%;
  transform: translate(-50%, -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@media (min-width: 1236px) {

  .index_intro__badge {
    font-size: 12px;
  }
}

.index_intro__image {
  display: block;
  height: 100%;
  width: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: center;
     object-position: center;
  opacity: 0.65;
}

.index_seminar__frame {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 0;
  height: 380px;
  width: 100vw;
  --tw-bg-opacity: 1;
  background-color: rgba(245, 249, 255, 1);
  background-color: rgba(245, 249, 255, var(--tw-bg-opacity));
  opacity: 0.6;
}

@media (min-width: 1236px) {

  .index_seminar__frame {
    height: 380px;
  }
}

.index_seminar__back {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -10;
  height: 380px;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgba(26, 119, 197, 1);
  background-color: rgba(26, 119, 197, var(--tw-bg-opacity));
  opacity: 0.4;
}

@media (min-width: 1236px) {

  .index_seminar__back {
    height: 380px;
  }
}

.index_pickup__back {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 10;
  display: block;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgba(26, 119, 197, 1);
  background-color: rgba(26, 119, 197, var(--tw-bg-opacity));
}

@media (min-width: 1236px) {

  .index_pickup__back {
    height: 530px;
  }
}

.index_pickup__frame {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 380px;
  width: 100vw;
  --tw-bg-opacity: 1;
  background-color: rgba(7, 53, 137, 1);
  background-color: rgba(7, 53, 137, var(--tw-bg-opacity));
}

@media (min-width: 1236px) {

  .index_pickup__frame {
    height: 550px;
  }
}

.faq_block {
  overflow: hidden;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(226, 232, 240, 1);
  border-color: rgba(226, 232, 240, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.faq_title {
  display: flex;
  width: 100%;
  align-items: center;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  padding-right: 2.5rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

@media (min-width: 768px) {

  .faq_title {
    padding-right: 4rem;
  }
}

.faq_title__badge {
  width: 2.0em;
  flex-shrink: 0;
  text-align: center;
  font-size: 1.5em;
}

@media (min-width: 768px) {

  .faq_title__badge {
    width: 2.8em;
    font-size: 2em;
  }
}

.input_text {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  border-width: 1px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.select {
  position: relative;
  height: 50px;
  width: 100%;
  min-width: 200px;
  border-radius: 4px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(226, 232, 240, 1);
  border-color: rgba(226, 232, 240, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.select_icon {
  position: absolute;
  right: 0.75rem;
  --tw-text-opacity: 1;
  color: rgba(241, 24, 71, 1);
  color: rgba(241, 24, 71, var(--tw-text-opacity));
  top: 50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.form_intro {
  margin-bottom: 2.5rem;
  padding: 1.25rem;
  text-align: center;
  line-height: 2rem;
}

.single_program {
  border-radius: 0.125rem;
  border-width: 4px;
  --tw-border-opacity: 1;
  border-color: rgba(99, 151, 195, 1);
  border-color: rgba(99, 151, 195, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(248, 250, 252, 1);
  background-color: rgba(248, 250, 252, var(--tw-bg-opacity));
}

.single_program__title {
  display: flex;
  align-items: center;
  justify-content: center;
  --tw-bg-opacity: 1;
  background-color: rgba(99, 151, 195, 1);
  background-color: rgba(99, 151, 195, var(--tw-bg-opacity));
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  font-size: 1.15rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

@media (min-width: 976px) {

  .single_program__title {
    min-height: 4.5em;
    font-size: 1.24rem;
  }
}

.single_program__body {
  padding: 1rem;
  font-weight: 700;
  line-height: 2rem;
}

@media (min-width: 976px) {

  .single_program__body {
    padding: 1.75rem;
    font-size: 1.15rem;
  }
}

.single_program__more {
  padding: 2.5rem;
  font-size: 1.24rem;
  font-weight: 700;
  line-height: 2rem;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

@media (min-width: 976px) {

  .single_program__more {
    padding: 3rem;
  }
}

.confirm_label {
  white-space: pre-wrap;
}

/* .button {
  @apply cursor-pointer relative inline-block mx-auto border-0 min-w-[280px] text-center py-6 pl-10 pr-10 outline-none transition-all duration-500 ease-in-out overflow-hidden rounded-sm shadow-md hover:shadow-none tracking-widest;
}

.button_sub {
  @apply inline-block text-left relative py-4 pl-8 pr-14 rounded-full;
}

.button_primary {
  @apply border border-primary-dark text-white bg-gradient-to-tr from-primary-dark to-primary hover:from-primary-dark hover:to-primary-dark;
} */

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.mb-10 {
  margin-bottom: 2.5rem;
}

.ml-0 {
  margin-left: 0px;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-20 {
  margin-top: 5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.flex {
  display: flex;
}

.table {
  display: table;
}

.hidden {
  display: none;
}

.h-2 {
  height: 0.5rem;
}

.h-full {
  height: 100%;
}

.w-2 {
  width: 0.5rem;
}

.w-\\[50\\%\\] {
  width: 50%;
}

.w-full {
  width: 100%;
}

.max-w-\\[80\\%\\] {
  max-width: 80%;
}

.max-w-full {
  max-width: 100%;
}

@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.flex-col {
  flex-direction: column;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-4 {
  gap: 1rem;
}

.rounded-full {
  border-radius: 9999px;
}

.border-4 {
  border-width: 4px;
}

.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, 1);
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
}

.bg-gray {
  --tw-bg-opacity: 1;
  background-color: rgba(89, 87, 87, 1);
  background-color: rgba(89, 87, 87, var(--tw-bg-opacity));
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}

.p-8 {
  padding: 2rem;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-40 {
  padding-top: 10rem;
  padding-bottom: 10rem;
}

.\\!pt-0 {
  padding-top: 0px !important;
}

.pb-20 {
  padding-bottom: 5rem;
}

.pb-4 {
  padding-bottom: 1rem;
}

.pl-5 {
  padding-left: 1.25rem;
}

.pt-20 {
  padding-top: 5rem;
}

.pt-4 {
  padding-top: 1rem;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-2xl {
  font-size: 1.4rem;
}

.text-sm {
  font-size: 0.86rem;
}

.text-xs {
  font-size: 0.8rem;
}

.font-normal {
  font-weight: 400;
}

.text-red-600 {
  --tw-text-opacity: 1;
  color: rgba(220, 38, 38, 1);
  color: rgba(220, 38, 38, var(--tw-text-opacity));
}

.opacity-0 {
  opacity: 0;
}

.hover\\:text-gray:hover {
  --tw-text-opacity: 1;
  color: rgba(89, 87, 87, 1);
  color: rgba(89, 87, 87, var(--tw-text-opacity));
}

@media (min-width: 768px) {

  .md\\:max-w-\\[50\\%\\] {
    max-width: 50%;
  }

  .md\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
}

@media (min-width: 976px) {

  .lg\\:block {
    display: block;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:max-w-\\[33\\.3333\\%\\] {
    max-width: 33.3333%;
  }
}

@media (min-width: 1236px) {

  .xl\\:w-2\\/3 {
    width: 66.666667%;
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:p-10 {
    padding: 2.5rem;
  }

  .xl\\:p-20 {
    padding: 5rem;
  }

  .xl\\:text-base {
    font-size: 1.0rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/js/module/tailwind.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,8LAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,0BAAc;EAAd,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAGZ;EAAA,iBAA2D;EAA3D,kBAA2D;EAA3D,WAA2D;EAA3D,iBAA2D;EAA3D,oBAA2D;EAA3D;AAA2D;AAA3D;;EAAA;IAAA,oBAA2D;IAA3D;EAA2D;AAAA;AAA3D;;EAAA;IAAA,kBAA2D;IAA3D;EAA2D;AAAA;AAG3D;EAAA,iBAA2D;EAA3D,kBAA2D;EAA3D,WAA2D;EAA3D,iBAA2D;EAA3D,oBAA2D;EAA3D;AAA2D;AAA3D;;EAAA;IAAA,oBAA2D;IAA3D;EAA2D;AAAA;AAA3D;;EAAA;IAAA,kBAA2D;IAA3D;EAA2D;AAAA;AAG3D;EAAA,iBAA2D;EAA3D,kBAA2D;EAA3D,WAA2D;EAA3D,iBAA2D;EAA3D,oBAA2D;EAA3D;AAA2D;AAA3D;;EAAA;IAAA,oBAA2D;IAA3D;EAA2D;AAAA;AAA3D;;EAAA;IAAA,kBAA2D;IAA3D;EAA2D;AAAA;AAG3D;EAAA,iBAA2D;EAA3D,kBAA2D;EAA3D,WAA2D;EAA3D,iBAA2D;EAA3D,iBAA2D;EAA3D;AAA2D;AAA3D;;EAAA;IAAA,oBAA2D;IAA3D;EAA2D;AAAA;AAA3D;;EAAA;IAAA,kBAA2D;IAA3D;EAA2D;AAAA;;AAI3D;EAAA,iBAA0D;EAA1D,kBAA0D;EAA1D,WAA0D;EAA1D,gBAA0D;EAA1D,oBAA0D;EAA1D;AAA0D;;AAA1D;;EAAA;IAAA,oBAA0D;IAA1D;EAA0D;AAAA;;AAA1D;;EAAA;IAAA,kBAA0D;IAA1D;EAA0D;AAAA;AAG1D;EAAA,QAAmC;EAAnC,sBAAmC;EAAnC,8KAAmC;EAAnC;AAAmC;AAGnC;EAAA,SAAoC;EAApC,sBAAoC;EAApC,8KAAoC;EAApC;AAAoC;;AAIpC;EAAA,kBAAyC;EAAzC,cAAyC;EAAzC;AAAyC;;AAAzC;;EAAA;IAAA;EAAyC;AAAA;;AAIzC;EAAA,aAAuC;EAAvC,WAAuC;EAAvC,kBAAuC;EAAvC;AAAuC;;AAAvC;;EAAA;IAAA;EAAuC;AAAA;;AAAvC;;EAAA;IAAA,oBAAuC;IAAvC;EAAuC;AAAA;AAGvC;EAAA,YAAkC;EAAlC;AAAkC;AAAlC;;EAAA;IAAA;EAAkC;AAAA;AAGlC;EAAA,aAAmC;EAAnC,sBAAmC;EAAnC,YAAmC;EAAnC;AAAmC;AAGnC;EAAA,mBAA2E;EAA3E,eAA2E;EAA3E,gBAA2E;EAA3E;AAA2E;AAA3E;;EAAA;IAAA;EAA2E;AAAA;AAG3E;EAAA,aAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;AAG9B;EAAA,mBAA2E;EAA3E,eAA2E;EAA3E,gBAA2E;EAA3E;AAA2E;AAA3E;;EAAA;IAAA;EAA2E;AAAA;AAG3E;EAAA;AAAe;;AAIf;EAAA,qBAAgC;EAAhC;AAAgC;AAGhC;EAAA,kBAAgD;EAAhD,SAAgD;EAAhD,QAAgD;EAAhD,cAAgD;EAAhD,YAAgD;EAAhD;AAAgD;AAGhD;EAAA;AAAe;AAGf;EAAA,aAA8C;EAA9C,sBAA8C;EAA9C,qBAA8C;EAA9C,YAA8C;EAA9C;AAA8C;AAG9C;EAAA,eAAgC;EAAhC;AAAgC;AAGhC;EAAA,eAA+C;EAA/C,gBAA+C;EAA/C;AAA+C;;AAI/C;EAAA,aAAiD;EAAjD,YAAiD;EAAjD,mBAAiD;EAAjD;AAAiD;;AAIjD;EAAA,gBAA2E;EAA3E,oBAA2E;EAA3E,4BAA2E;EAA3E,qBAA2E;EAA3E,+BAA2E;EAA3E,eAA2E;EAA3E;AAA2E;;AAA3E;;EAAA;IAAA;EAA2E;AAAA;;AAA3E;;EAAA;IAAA;EAA2E;AAAA;;AAI3E;EAAA,kBAAmF;EAAnF,uBAAmF;EAAnF,kBAAmF;EAAnF,mBAAmF;EAAnF,iBAAmF;EAAnF,oBAAmF;EAAnF,kBAAmF;EAAnF;AAAmF;;AAAnF;;EAAA;IAAA,kBAAmF;IAAnF,mBAAmF;IAAnF,mBAAmF;IAAnF,sBAAmF;IAAnF;EAAmF;AAAA;AAGnF;EAAA,kBAAgD;EAAhD,cAAgD;EAAhD,WAAgD;EAAhD,UAAgD;EAAhD,QAAgD;EAAhD,sBAAgD;EAAhD,8KAAgD;EAAhD;AAAgD;AAGhD;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;;AAInB;EAAA,aAAyG;EAAzG,WAAyG;EAAzG,mBAAyG;EAAzG,uBAAyG;EAAzG,kBAAyG;EAAzG,wCAAyG;EAAzG,2DAAyG;EAAzG,kBAAyG;EAAzG,mBAAyG;EAAzG,oBAAyG;EAAzG,uBAAyG;EAAzG,gBAAyG;EAAzG,gBAAyG;EAAzG,oBAAyG;EAAzG,uBAAyG;EAAzG,4CAAyG;EAAzG,4CAAyG;EAAzG,uDAAyG;EAAzG,iFAAyG;EAAzG;AAAyG;;AAIzG;EAAA,iBAA6B;EAA7B,oBAA6B;EAA7B,2BAA6B;EAA7B;AAA6B;;AAI7B;EAAA,aAAsF;EAAtF,sBAAsF;EAAtF,yBAAsF;EAAtF,YAAsF;EAAtF,qBAAsF;EAAtF,sBAAsF;EAAtF,oCAAsF;EAAtF,2DAAsF;EAAtF,aAAsF;EAAtF;AAAsF;;AAAtF;;EAAA;IAAA;EAAsF;AAAA;AAGtF;EAAA,oBAA+K;EAA/K,cAA+K;EAA/K,mBAA+K;EAA/K,uBAA+K;EAA/K,uBAA+K;EAA/K,mBAA+K;EAA/K,sBAA+K;EAA/K,oBAA+K;EAA/K,qBAA+K;EAA/K,kBAA+K;EAA/K,kBAA+K;EAA/K,gBAA+K;EAA/K,4CAA+K;EAA/K,uDAA+K;EAA/K,iFAA+K;EAA/K,uHAA+K;EAA/K,8BAA+K;EAA/K,mBAA+K;EAA/K,wBAA+K;EAA/K,wDAA+K;EAA/K;AAA+K;;AAI/K;EAAA,kBAAoD;EAApD,wCAAoD;EAApD,2DAAoD;EAApD,oBAAoD;EAApD,uBAAoD;EAApD;AAAoD;;AAApD;EAAA,kBAAoD;EAApD,wCAAoD;EAApD;AAAoD;;AAIpD;EAAA,iBAAoF;EAApF,sBAAoF;EAApF,kCAAoF;EAApF,yDAAoF;EAApF,kBAAoF;EAApF,wCAAoF;EAApF,2DAAoF;EAApF,oBAAoF;EAApF,2BAAoF;EAApF;AAAoF;;AAApF;EAAA,kBAAoF;EAApF,sCAAoF;EAApF,yDAAoF;EAApF,oBAAoF;EAApF,6BAAoF;EAApF;AAAoF;;AAIpF;EAAA,cAA0F;EAA1F,YAA0F;EAA1F,iBAA0F;EAA1F,6BAA0F;EAA1F,kBAA0F;EAA1F,mBAA0F;EAA1F,oBAA0F;EAA1F,uBAA0F;EAA1F,iBAA0F;EAA1F,oBAA0F;EAA1F,uBAA0F;EAA1F;AAA0F;;AAA1F;;EAAA;IAAA;EAA0F;AAAA;;AAI1F;EAAA,gBAAkE;EAAlE,uBAAkE;EAAlE,iBAAkE;EAAlE,sBAAkE;EAAlE,oCAAkE;EAAlE,2DAAkE;EAAlE,kBAAkE;EAAlE,wCAAkE;EAAlE;AAAkE;;AAIlE;EAAA,aAAsE;EAAtE,WAAsE;EAAtE,mBAAsE;EAAtE,oBAAsE;EAAtE,uBAAsE;EAAtE,mBAAsE;EAAtE,wBAAsE;EAAtE,wDAAsE;EAAtE;AAAsE;;AAItE;EAAA,YAAgG;EAAhG,cAAgG;EAAhG,kBAAgG;EAAhG,gBAAgG;EAAhG,oBAAgG;EAAhG,4BAAgG;EAAhG;AAAgG;;AAAhG;;EAAA;IAAA,YAAgG;IAAhG;EAAgG;;EAIhG;IAAA;EAAiB;AAJ+E;;AAQhG;EAAA,kBAAc;EAAd,wCAAc;EAAd;AAAc;;AAId;EAAA,aAA8B;EAA9B,oBAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;;AAA9B;;EAAA;IAAA,mBAA8B;IAA9B;EAA8B;AAAA;;AAI9B;EAAA,YAA2F;EAA3F,cAA2F;EAA3F,kBAA2F;EAA3F,gBAA2F;EAA3F,oBAA2F;EAA3F,2BAA2F;EAA3F;AAA2F;;AAA3F;;EAAA;IAAA,YAA2F;IAA3F;EAA2F;AAAA;;AAI3F;EAAA;AAAqD;;AAArD;;EAAA;IAAA,qBAAqD;IAArD,kBAAqD;IAArD;EAAqD;AAAA;;AAIrD;EAAA,aAAgC;EAAhC;AAAgC;;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAGhC;EAAA,WAAwD;EAAxD,cAAwD;EAAxD,eAAwD;EAAxD;AAAwD;AAAxD;;EAAA;IAAA,WAAwD;IAAxD;EAAwD;AAAA;AAGxD;EAAA,WAAuC;EAAvC,YAAuC;EAAvC,kBAAuC;EAAvC;AAAuC;;AAIvC;EAAA,aAAqB;EAArB;AAAqB;;AAIrB;EAAA,kBAAgI;EAAhI,iBAAgI;EAAhI,qBAAgI;EAAhI,sBAAgI;EAAhI,kCAAgI;EAAhI,yDAAgI;EAAhI,kBAAgI;EAAhI,qCAAgI;EAAhI,wDAAgI;EAAhI,eAAgI;EAAhI,oBAAgI;EAAhI,qBAAgI;EAAhI,kBAAgI;EAAhI,oBAAgI;EAAhI,6BAAgI;EAAhI;AAAgI;;AAAhI;;EAAA;IAAA,iBAAgI;IAAhI;EAAgI;AAAA;;AAIhI;EAAA,kBAA4H;EAA5H,aAA4H;EAA5H,WAA4H;EAA5H,eAA4H;EAA5H,mBAA4H;EAA5H,oBAA4H;EAA5H,6BAA4H;EAA5H,kDAA4H;EAA5H,YAA4H;EAA5H,sBAA4H;EAA5H,SAA4H;EAA5H,sBAA4H;EAA5H,8KAA4H;EAA5H;AAA4H;;AAA5H;;EAAA;IAAA;EAA4H;AAAA;;AAI5H;EAAA,aAAuE;EAAvE,mBAAuE;EAAvE,oCAAuE;EAAvE,mCAAuE;EAAvE,qBAAuE;EAAvE,sBAAuE;EAAvE,mBAAuE;EAAvE,sBAAuE;EAAvE,wBAAuE;EAAvE,wDAAuE;EAAvE;AAAuE;;AAAvE;;EAAA;IAAA,kBAAuE;IAAvE;EAAuE;AAAA;;AAIvE;EAAA,6BAAkB;EAAlB,mDAAkB;EAAlB;AAAkB;;AAIlB;EAAA,cAAsH;EAAtH,eAAsH;EAAtH,gCAAsH;EAAtH,iCAAsH;EAAtH,mBAAsH;EAAtH,oBAAsH;EAAtH,iBAAsH;EAAtH,oBAAsH;EAAtH,wBAAsH;EAAtH,wDAAsH;EAAtH;AAAsH;;AAAtH;EAAA,kBAAsH;EAAtH,wCAAsH;EAAtH;AAAsH;;AAAtH;;EAAA;IAAA,mBAAsH;IAAtH;EAAsH;AAAA;;AAItH;EAAA,6BAAkB;EAAlB,mDAAkB;EAAlB;AAAkB;;AAIlB;EAAA,kBAA4E;EAA5E,WAA4E;EAA5E,SAA4E;EAA5E,cAA4E;EAA5E,WAA4E;EAA5E,WAA4E;EAA5E,kBAA4E;EAA5E,wCAA4E;EAA5E,2DAA4E;EAA5E;AAA4E;;AAG9E;;GAEG;;AAGD;EAAA,aAAwM;EAAxM,YAAwM;EAAxM,WAAwM;EAAxM,mBAAwM;EAAxM,uBAAwM;EAAxM,uBAAwM;EAAxM,iBAAwM;EAAxM,sBAAwM;EAAxM,oCAAwM;EAAxM,2DAAwM;EAAxM,kBAAwM;EAAxM,wCAAwM;EAAxM,2DAAwM;EAAxM,kBAAwM;EAAxM,kBAAwM;EAAxM,gBAAwM;EAAxM,oBAAwM;EAAxM,4BAAwM;EAAxM,iDAAwM;EAAxM,iFAAwM;EAAxM,iGAAwM;EAAxM,sHAAwM;EAAxM,uHAAwM;EAAxM,wBAAwM;EAAxM,wDAAwM;EAAxM;AAAwM;;AAAxM;EAAA,kBAAwM;EAAxM,wCAAwM;EAAxM;AAAwM;;AAIxM;EAAA,qBAAiF;EAAjF,qBAAiF;EAAjF,oBAAiF;EAAjF,qBAAiF;EAAjF,oBAAiF;EAAjF,uBAAiF;EAAjF,iBAAiF;EAAjF,gBAAiF;EAAjF;AAAiF;;AAAjF;;EAAA;IAAA,qBAAiF;IAAjF;EAAiF;AAAA;;AAIjF;EAAA,qBAA4G;EAA5G,WAA4G;EAA5G,uBAA4G;EAA5G,qBAA4G;EAA5G,sBAA4G;EAA5G,mBAA4G;EAA5G,sBAA4G;EAA5G,kBAA4G;EAA5G,kBAA4G;EAA5G,gBAA4G;EAA5G;AAA4G;;AAA5G;;EAAA;IAAA,WAA4G;IAA5G,oBAA4G;IAA5G;EAA4G;AAAA;;AAI5G;EAAA,aAAsE;EAAtE,mBAAsE;EAAtE,uBAAsE;EAAtE,uBAAsE;EAAtE,qBAAsE;EAAtE,sBAAsE;EAAtE,mBAAsE;EAAtE,sBAAsE;EAAtE;AAAsE;;AAItE;EAAA,cAAkF;EAAlF,uBAAkF;EAAlF,kBAAkF;EAAlF,wCAAkF;EAAlF,2DAAkF;EAAlF,iBAAkF;EAAlF,oBAAkF;EAAlF,kBAAkF;EAAlF,mBAAkF;EAAlF;AAAkF;;AAAlF;EAAA,kBAAkF;EAAlF,wCAAkF;EAAlF;AAAkF;;AAAlF;;EAAA;IAAA,oBAAkF;IAAlF;EAAkF;AAAA;;AAIlF;EAAA,aAAiD;EAAjD,eAAiD;EAAjD;AAAiD;;AAAjD;;EAAA;IAAA;EAAiD;AAAA;;AAIjD;EAAA,aAAmF;EAAnF,WAAmF;EAAnF,cAAmF;EAAnF,eAAmF;EAAnF,WAAmF;EAAnF;AAAmF;;AAAnF;;EAAA;IAAA,YAAmF;IAAnF,mBAAmF;IAAnF;EAAmF;AAAA;;AAInF;EAAA,cAA4C;EAA5C,YAA4C;EAA5C;AAA4C;;AAI5C;EAAA,kBAAyC;EAAzC;AAAyC;;AAAzC;;EAAA;IAAA,WAAyC;IAAzC;EAAyC;AAAA;;AAIzC;EAAA,aAAgD;EAAhD,mBAAgD;EAAhD;AAAgD;;AAAhD;;EAAA;IAAA,WAAgD;IAAhD;EAAgD;AAAA;;AAIhD;EAAA,aAA0F;EAA1F,mBAA0F;EAA1F,uBAA0F;EAA1F,uBAA0F;EAA1F,oBAA0F;EAA1F,qBAA0F;EAA1F,oBAA0F;EAA1F,uBAA0F;EAA1F,kBAA0F;EAA1F,kBAA0F;EAA1F;AAA0F;;AAI1F;EAAA,aAAsC;EAAtC,eAAsC;EAAtC;AAAsC;;AAAtC;;EAAA;IAAA;EAAsC;AAAA;;AAItC;EAAA,iBAAoF;EAApF,sBAAoF;EAApF,kCAAoF;EAApF,yDAAoF;EAApF,kBAAoF;EAApF,wCAAoF;EAApF,2DAAoF;EAApF,oBAAoF;EAApF,2BAAoF;EAApF;AAAoF;;AAApF;EAAA,kBAAoF;EAApF,sCAAoF;EAApF,yDAAoF;EAApF,oBAAoF;EAApF,6BAAoF;EAApF;AAAoF;;AAIpF;EAAA,kBAA8D;EAA9D,aAA8D;EAA9D,sBAA8D;EAA9D;AAA8D;;AAA9D;;EAAA;IAAA;EAA8D;AAAA;;AAA9D;;EAAA;IAAA,QAA8D;IAA9D;EAA8D;AAAA;;AAI9D;EAAA,kBAAkF;EAAlF,aAAkF;EAAlF,sBAAkF;EAAlF,gBAAkF;EAAlF,qBAAkF;EAAlF,kBAAkF;EAAlF,wCAAkF;EAAlF;AAAkF;;AAAlF;;EAAA;IAAA;EAAkF;AAAA;;AAIlF;EAAA,kBAAoI;EAApI,cAAoI;EAApI,SAAoI;EAApI,aAAoI;EAApI,YAAoI;EAApI,WAAoI;EAApI,mBAAoI;EAApI,uBAAoI;EAApI,qBAAoI;EAApI,kBAAoI;EAApI,uCAAoI;EAApI,0DAAoI;EAApI,eAAoI;EAApI,oBAAoI;EAApI,6BAAoI;EAApI;AAAoI;;AAIpI;EAAA,aAAuG;EAAvG,2BAAuG;EAAvG,mBAAuG;EAAvG,8BAAuG;EAAvG,qBAAuG;EAAvG,sBAAuG;EAAvG,mBAAuG;EAAvG;AAAuG;;AAAvG;;EAAA;IAAA,mBAAuG;IAAvG;EAAuG;AAAA;;AAAvG;;EAAA;IAAA;EAAuG;AAAA;;AAIvG;EAAA,aAAgF;EAAhF,YAAgF;EAAhF,WAAgF;EAAhF,mBAAgF;EAAhF,uBAAgF;EAAhF,qBAAgF;EAAhF,kBAAgF;EAAhF,kCAAgF;EAAhF,qDAAgF;EAAhF,oBAAgF;EAAhF,6BAAgF;EAAhF;AAAgF;;AAIhF;EAAA,aAA2E;EAA3E,cAA2E;EAA3E;AAA2E;;AAA3E;;EAAA;IAAA;EAA2E;AAAA;;AAA3E;;EAAA;IAAA,aAA2E;IAA3E,gDAA2E;IAA3E;EAA2E;AAAA;;AAI3E;EAAA,kBAAsK;EAAtK,aAAsK;EAAtK,mBAAsK;EAAtK,gBAAsK;EAAtK,uBAAsK;EAAtK,kBAAsK;EAAtK,qCAAsK;EAAtK,wDAAsK;EAAtK,oBAAsK;EAAtK,6BAAsK;EAAtK,kDAAsK;EAAtK,iFAAsK;EAAtK,iGAAsK;EAAtK,sHAAsK;EAAtK,uHAAsK;EAAtK,wBAAsK;EAAtK,wDAAsK;EAAtK;AAAsK;;AAAtK;EAAA,kBAAsK;EAAtK,uCAAsK;EAAtK,0DAAsK;EAAtK,8BAAsK;EAAtK,sCAAsK;EAAtK,mEAAsK;EAAtK;AAAsK;;AAItK;EAAA,kBAA8D;EAA9D,SAA8D;EAA9D,WAA8D;EAA9D,cAA8D;EAA9D,YAA8D;EAA9D,WAA8D;EAA9D;AAA8D;;AAI9D;EAAA,kBAAuE;EAAvE,WAAuE;EAAvE,aAAuE;EAAvE,sBAAuE;EAAvE,kBAAuE;EAAvE,mBAAuE;EAAvE,oBAAuE;EAAvE,uBAAuE;EAAvE;AAAuE;;AAAvE;;EAAA;IAAA,mBAAuE;IAAvE;EAAuE;AAAA;;AAAvE;;EAAA;IAAA,oBAAuE;IAAvE;EAAuE;AAAA;;AAIvE;EAAA,kBAAoI;EAApI,aAAoI;EAApI,aAAoI;EAApI,YAAoI;EAApI,WAAoI;EAApI,mBAAoI;EAApI,uBAAoI;EAApI,qBAAoI;EAApI,kBAAoI;EAApI,wCAAoI;EAApI,2DAAoI;EAApI,eAAoI;EAApI,oBAAoI;EAApI,2BAAoI;EAApI,gDAAoI;EAApI,QAAoI;EAApI,sBAAoI;EAApI,8KAAoI;EAApI;AAAoI;;AAIpI;EAAA,kBAAiJ;EAAjJ,aAAiJ;EAAjJ,WAAiJ;EAAjJ,eAAiJ;EAAjJ,uBAAiJ;EAAjJ,kBAAiJ;EAAjJ,uCAAiJ;EAAjJ,0DAAiJ;EAAjJ,iBAAiJ;EAAjJ,oBAAiJ;EAAjJ,kBAAiJ;EAAjJ,mBAAiJ;EAAjJ,oBAAiJ;EAAjJ,6BAAiJ;EAAjJ,kDAAiJ;EAAjJ,wBAAiJ;EAAjJ,wDAAiJ;EAAjJ;AAAiJ;;AAAjJ;EAAA,kBAAiJ;EAAjJ,qCAAiJ;EAAjJ;AAAiJ;;AAAjJ;;EAAA;IAAA,mBAAiJ;IAAjJ;EAAiJ;AAAA;;AAIjJ;EAAA,kBAAiK;EAAjK,QAAiK;EAAjK,WAAiK;EAAjK,sBAAiK;EAAjK,uBAAiK;EAAjK,kBAAiK;EAAjK,uCAAiK;EAAjK,0DAAiK;EAAjK,kBAAiK;EAAjK,mBAAiK;EAAjK,eAAiK;EAAjK,gBAAiK;EAAjK,iBAAiK;EAAjK,uBAAiK;EAAjK,oBAAiK;EAAjK,6BAAiK;EAAjK,kDAAiK;EAAjK,SAAiK;EAAjK,sBAAiK;EAAjK,6JAAiK;EAAjK;AAAiK;;AAAjK;;EAAA;IAAA;EAAiK;AAAA;;AAIjK;EAAA,cAAiE;EAAjE,YAAiE;EAAjE,WAAiE;EAAjE,oBAAiE;KAAjE,iBAAiE;EAAjE,0BAAiE;KAAjE,uBAAiE;EAAjE;AAAiE;;AAIjE;EAAA,kBAAyF;EAAzF,QAAyF;EAAzF,SAAyF;EAAzF,UAAyF;EAAzF,aAAyF;EAAzF,YAAyF;EAAzF,kBAAyF;EAAzF,wCAAyF;EAAzF,2DAAyF;EAAzF;AAAyF;;AAAzF;;EAAA;IAAA;EAAyF;AAAA;;AAIzF;EAAA,kBAA2F;EAA3F,QAA2F;EAA3F,SAA2F;EAA3F,YAA2F;EAA3F,aAA2F;EAA3F,WAA2F;EAA3F,kBAA2F;EAA3F,uCAA2F;EAA3F,0DAA2F;EAA3F;AAA2F;;AAA3F;;EAAA;IAAA;EAA2F;AAAA;;AAI3F;EAAA,kBAA2E;EAA3E,SAA2E;EAA3E,QAA2E;EAA3E,WAA2E;EAA3E,cAA2E;EAA3E,WAA2E;EAA3E,kBAA2E;EAA3E,uCAA2E;EAA3E;AAA2E;;AAA3E;;EAAA;IAAA;EAA2E;AAAA;;AAI3E;EAAA,kBAA6E;EAA7E,QAA6E;EAA7E,SAA6E;EAA7E,aAA6E;EAA7E,YAA6E;EAA7E,kBAA6E;EAA7E,qCAA6E;EAA7E;AAA6E;;AAA7E;;EAAA;IAAA;EAA6E;AAAA;;AAI7E;EAAA,gBAAkE;EAAlE,uBAAkE;EAAlE,iBAAkE;EAAlE,sBAAkE;EAAlE,oCAAkE;EAAlE,2DAAkE;EAAlE,kBAAkE;EAAlE,wCAAkE;EAAlE;AAAkE;;AAIlE;EAAA,aAA+E;EAA/E,WAA+E;EAA/E,mBAA+E;EAA/E,oBAA+E;EAA/E,uBAA+E;EAA/E,qBAA+E;EAA/E,wBAA+E;EAA/E,wDAA+E;EAA/E;AAA+E;;AAA/E;;EAAA;IAAA;EAA+E;AAAA;;AAI/E;EAAA,YAA6E;EAA7E,cAA6E;EAA7E,kBAA6E;EAA7E;AAA6E;;AAA7E;;EAAA;IAAA,YAA6E;IAA7E;EAA6E;AAAA;;AAI7E;EAAA,sBAAoD;EAApD,WAAoD;EAApD,eAAoD;EAApD,iBAAoD;EAApD,kBAAoD;EAApD,mBAAoD;EAApD,mBAAoD;EAApD;AAAoD;;AAIpD;EAAA,kBAA4F;EAA5F,YAA4F;EAA5F,WAA4F;EAA5F,gBAA4F;EAA5F,kBAA4F;EAA5F,iBAA4F;EAA5F,sBAA4F;EAA5F,oCAA4F;EAA5F,2DAA4F;EAA5F,kBAA4F;EAA5F,wCAA4F;EAA5F;AAA4F;;AAI5F;EAAA,kBAAiD;EAAjD,cAAiD;EAAjD,oBAAiD;EAAjD,2BAAiD;EAAjD,gDAAiD;EAAjD,QAAiD;EAAjD,sBAAiD;EAAjD,8KAAiD;EAAjD;AAAiD;;AAIjD;EAAA,qBAAwC;EAAxC,gBAAwC;EAAxC,kBAAwC;EAAxC;AAAwC;;AAIxC;EAAA,uBAA0D;EAA1D,iBAA0D;EAA1D,sBAA0D;EAA1D,mCAA0D;EAA1D,0DAA0D;EAA1D,kBAA0D;EAA1D,wCAA0D;EAA1D;AAA0D;;AAI1D;EAAA,aAAsI;EAAtI,mBAAsI;EAAtI,uBAAsI;EAAtI,kBAAsI;EAAtI,uCAAsI;EAAtI,0DAAsI;EAAtI,iBAAsI;EAAtI,oBAAsI;EAAtI,oBAAsI;EAAtI,qBAAsI;EAAtI,kBAAsI;EAAtI,kBAAsI;EAAtI,gBAAsI;EAAtI,oBAAsI;EAAtI,6BAAsI;EAAtI;AAAsI;;AAAtI;;EAAA;IAAA,iBAAsI;IAAtI;EAAsI;AAAA;;AAItI;EAAA,aAAgD;EAAhD,gBAAgD;EAAhD;AAAgD;;AAAhD;;EAAA;IAAA,gBAAgD;IAAhD;EAAgD;AAAA;;AAIhD;EAAA,eAA6D;EAA7D,kBAA6D;EAA7D,gBAA6D;EAA7D,iBAA6D;EAA7D,oBAA6D;EAA7D,uBAA6D;EAA7D;AAA6D;;AAA7D;;EAAA;IAAA;EAA6D;AAAA;;AAI7D;EAAA;AAA0B;;AAG5B;;;;;;;;;;GAUG;;AAEH;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;;EAAA;IAAA;EAAmB;AAAA;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AArXnB;EAAA,oBAsXA;EAtXA,0BAsXA;EAtXA;AAsXA;;AAtXA;;EAAA;IAAA;EAsXA;;EAtXA;IAAA,iBAsXA;IAtXA;EAsXA;AAAA;;AAtXA;;EAAA;IAAA;EAsXA;;EAtXA;IAAA;EAsXA;;EAtXA;IAAA;EAsXA;AAAA;;AAtXA;;EAAA;IAAA;EAsXA;;EAtXA;IAAA;EAsXA;;EAtXA;IAAA;EAsXA;;EAtXA;IAAA;EAsXA;;EAtXA;IAAA;EAsXA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n.container-wide {\n  @apply mx-auto px-6 md:px-10 xl:px-20 w-full max-w-[1920px];\n}\n.container-lg {\n  @apply mx-auto px-6 md:px-10 xl:px-20 w-full max-w-[1680px];\n}\n.container-md {\n  @apply mx-auto px-6 md:px-10 xl:px-20 w-full max-w-[1280px];\n}\n.container-web {\n  @apply mx-auto px-0 md:px-10 xl:px-20 w-full max-w-[1280px];\n}\n\n.container-sm {\n  @apply mx-auto px-6 md:px-10 xl:px-20 w-full max-w-[980px];\n}\n.top-middle {\n  @apply top-[50%] -translate-y-[50%];\n}\n.left-middle {\n  @apply left-[50%] -translate-x-[50%];\n}\n\n.gtranslate {\n  @apply relative md:w-[160px] h-full block;\n}\n\n.common_id {\n  @apply px-4 xl:px-6 flex gap-2 md:gap-3;\n}\n.common_id_image {\n  @apply w-auto h-[40px] md:h-[50px];\n}\n.common_id_contents {\n  @apply flex flex-col pt-[3px] gap-1;\n}\n.common_id_name {\n  @apply text-[20px] md:text-[24px] font-bold leading-[1em] whitespace-nowrap;\n}\n.common_id_seminar {\n  @apply flex items-center gap-2;\n}\n.common_id_seminar_text {\n  @apply text-[11px] md:text-[14px] font-bold leading-[1em] whitespace-nowrap;\n}\n.common_id_seminar_logo {\n  @apply w-[21px];\n}\n\n.page_logo {\n  @apply inline-block items-center;\n}\n.page_logo_frame {\n  @apply w-full h-full block absolute left-0 top-0;\n}\n.page_logo_image {\n  @apply w-[46px];\n}\n.page_logo_contents {\n  @apply flex flex-col gap-1 items-end font-bold;\n}\n.page_logo_name {\n  @apply leading-[1em] text-[16px];\n}\n.page_logo_note {\n  @apply leading-[1em] text-[12px] tracking-wider;\n}\n\n.topbar {\n  @apply h-[35px] flex items-center justify-between;\n}\n\n.topbar_contents {\n  @apply text-[11px] sm:text-xs xl:text-sm font-bold line-clamp-1 !pr-[120px];\n}\n\n.subtitle {\n  @apply text-xl xl:text-2xl font-bold rounded-sm  px-4 xl:px-8 py-4 xl:py-6 relative;\n}\n.subtitle_icon {\n  @apply absolute top-middle w-[6px] h-[1em] block;\n}\n.subtitle_label {\n  @apply pl-4 xl:pl-6;\n}\n\n.checkbox_menu_button {\n  @apply flex items-center w-full font-bold rounded-sm shadow-sm px-4 py-3 bg-white text-contrast text-left;\n}\n\n.checkbox_menu_button_icon {\n  @apply ml-auto text-secondary;\n}\n\n.checkbox_menu_submit {\n  @apply flex flex-col md:flex-row justify-end gap-3 pt-4 p-4  border-t border-slate-100;\n}\n.checkbox_menu_submit_item {\n  @apply min-w-[5em] py-2 px-6 shadow-sm inline-flex items-center justify-center text-center outline-none transition-all rounded-sm font-bold text-sm transition-all duration-500;\n}\n\n.checkbox_menu_reset {\n  @apply text-contrast bg-slate-200 hover:bg-slate-300;\n}\n\n.checkbox_menu_return {\n  @apply border border-primary text-primary hover:text-white bg-white hover:bg-primary;\n}\n\n.input_search {\n  @apply block text-base flex-1 border-0 bg-transparent px-4 py-3 text-contrast sm:leading-6;\n}\n\n.accordion_inner {\n  @apply rounded-md overflow-hidden bg-white border border-slate-200;\n}\n\n.accordion_title {\n  @apply flex items-center w-full py-5 pr-16 transition-all duration-300;\n}\n\n.accordion_title_badge {\n  @apply shrink-0  text-[1.5em] md:text-[2em] w-[2.0em] md:w-[2.8em] text-center text-primary-dark;\n}\n\n.accordion_title_label {\n  @apply md:text-xl;\n}\n\n.accordion_content {\n  @apply bg-back;\n}\n\n.accordion_content_inner {\n  @apply flex py-5 lg:py-10 pr-4;\n}\n\n.accordion_content_badge {\n  @apply shrink-0  text-[1.5em] md:text-[2em] w-[2.0em] md:w-[2.8em] text-center text-red-500;\n}\n\n.accordion_content_text {\n  @apply pt-[0.45rem] md:pt-2.5 md:text-lg md:leading-8;\n}\n\n.table dl {\n  @apply flex flex-col lg:flex-row;\n}\n.table dt {\n  @apply w-full lg:w-[14em] flex-shrink-0 pt-6 lg:pb-6 p-6;\n}\n.table dd {\n  @apply w-full flex-grow p-6 self-center;\n}\n\n.page_bread {\n  @apply flex flex-wrap;\n}\n\n.common_page_nav {\n  @apply relative text-center px-6 p-10 xl:p-16 bg-primary-black border-t border-primary text-white min-h-[120px] xl:min-h-[160px];\n}\n\n.common_page_eng {\n  @apply z-20 absolute left-middle -bottom-[18px] text-[10em] xl:text-[17em]  leading-3 text-white opacity-10 mix-blend-screen;\n}\n\n.menu_label {\n  @apply flex items-center px-3 2xl:px-4 py-2 transition-all rounded-b-md;\n}\n\n.menu_label.navigation_current {\n  @apply !bg-sky-100;\n}\n\n.navigation_label {\n  @apply px-[0.8vw] 2xl:px-[1.8vw] py-4 block cursor-pointer hover:bg-slate-100 rounded-t-md transition-all duration-300;\n}\n\n.navigation_label.navigation_current {\n  @apply !bg-sky-100;\n}\n\n.navigation_underline {\n  @apply w-full absolute bottom-0 left-0 block h-[4px] bg-slate-300 opacity-50;\n}\n\n/* .navigation_default.navigation_current {\n  @apply text-primary-gray-light;\n} */\n\n.navigation_button {\n  @apply shadow-md rounded-sm bg-white border border-white text-primary-dark text-sm font-bold h-[60px] w-full flex items-center justify-center text-center hover:bg-slate-200 transition-all duration-300;\n}\n\n.item_button {\n  @apply inline-block rounded-full px-2 md:px-3 py-1 text-xs font-bold duration-300;\n}\n\n.item_button_md {\n  @apply inline-block font-bold text-center px-3 py-2 md:py-1 rounded-sm text-sm w-full md:w-auto duration-300;\n}\n\n.item_button_base {\n  @apply flex items-center justify-center font-bold px-3 py-2 rounded-sm;\n}\n\n.seminar_item {\n  @apply block py-4 px-4 md:px-6 rounded-md bg-white hover:bg-slate-100 duration-300;\n}\n\n.seminar_item__inner {\n  @apply flex items-center flex-wrap md:flex-nowrap;\n}\n\n.seminar_item__aside {\n  @apply w-full md:w-[190px] pb-4 md:pb-0 md:pr-10 flex-shrink-0 flex flex-wrap gap-2;\n}\n\n.seminar_item__main {\n  @apply flex-grow flex-shrink  cursor-pointer;\n}\n\n.seminar_item__date_list {\n  @apply md:w-full flex md:flex-col mr-auto;\n}\n\n.seminar_item__badge_list {\n  @apply flex flex-row md:flex-col gap-2 md:w-full;\n}\n\n.seminar_item__badge_item {\n  @apply flex items-center justify-center text-center font-bold px-2 py-1 rounded-sm text-sm;\n}\n\n.seminar_item__category_list {\n  @apply md:order-3 flex flex-wrap gap-2;\n}\n\n.seminar_item__category_item {\n  @apply border border-primary text-primary bg-white hover:bg-primary hover:text-white;\n}\n\n.seminar_item__type_list {\n  @apply md:order-1 flex flex-col sm:flex-row gap-2 mt-2 md:mt-0;\n}\n\n.common_banner__item {\n  @apply flex flex-col md:flex-row bg-back-light relative overflow-hidden rounded-lg;\n}\n\n.common_banner__icon {\n  @apply text-[10px] absolute right-7 top-8 bg-primary-dark text-white rounded-full w-[32px] h-[32px] flex items-center justify-center;\n}\n\n.link_text {\n  @apply flex flex-row-reverse md:flex-row justify-between md:justify-start items-center px-3 py-2 xl:p-0;\n}\n\n.link_text__icon {\n  @apply bg-black text-white rounded-full w-4 h-4 flex items-center justify-center;\n}\n\n.index_banner {\n  @apply xl:h-[430px] grid lg:grid-cols-3 xl:grid-cols-1 xl:grid-rows-3 gap-4;\n}\n\n.index_banner__item {\n  @apply overflow-hidden relative bg-primary-black hover:bg-primary-dark text-white rounded-md shadow-md hover:shadow-none flex items-center transition-all duration-300;\n}\n\n.index_banner__image {\n  @apply absolute left-0 bottom-0 w-full h-full block opacity-70;\n}\n\n.index_banner__label {\n  @apply relative z-10 flex flex-col px-8 py-5 lg:py-10 xl:py-5 font-bold;\n}\n\n.index_banner__icon {\n  @apply absolute right-6 top-middle bg-white text-primary rounded-full w-[30px] h-[30px] text-[11px] flex items-center justify-center;\n}\n\n.index_intro__item {\n  @apply flex flex-wrap w-full py-8 sm:py-10 px-4 relative text-white bg-primary-dark hover:bg-primary-black transition-all duration-300 rounded-md;\n}\n\n.index_intro__badge {\n  @apply absolute top-0 -translate-y-[50%] left-middle z-10 px-4 bg-primary-dark text-white text-[12px] xl:text-[12px] font-bold leading-8 tracking-wide rounded-sm;\n}\n\n.index_intro__image {\n  @apply w-full object-cover h-full object-center block  opacity-65;\n}\n\n.index_seminar__frame {\n  @apply w-screen h-[380px] xl:h-[380px] absolute z-0 top-0 left-0 bg-back-light opacity-60;\n}\n\n.index_seminar__back {\n  @apply -z-10 absolute top-0 left-0 w-full h-[380px] xl:h-[380px] bg-primary-dark opacity-40;\n}\n\n.index_pickup__back {\n  @apply absolute left-0 top-0 w-full xl:h-[530px] block bg-primary-dark z-10;\n}\n\n.index_pickup__frame {\n  @apply w-screen h-[380px] xl:h-[550px] absolute top-0 left-0 bg-primary-black;\n}\n\n.faq_block {\n  @apply rounded-md overflow-hidden bg-white border border-slate-200;\n}\n\n.faq_title {\n  @apply flex items-center w-full py-5 pr-10 md:pr-16 transition-all duration-300;\n}\n\n.faq_title__badge {\n  @apply shrink-0 text-[1.5em] md:text-[2em] w-[2.0em] md:w-[2.8em] text-center;\n}\n\n.input_text {\n  @apply border px-4 py-2 w-full max-w-full box-border;\n}\n\n.select {\n  @apply border bg-white relative border-slate-200 rounded-[4px] w-full min-w-[200px] h-[50px];\n}\n\n.select_icon {\n  @apply absolute top-middle right-3 text-secondary;\n}\n\n.form_intro {\n  @apply p-5  text-center  leading-8 mb-10;\n}\n\n.single_program {\n  @apply bg-slate-50 border-4 border-primary-gray rounded-sm;\n}\n\n.single_program__title {\n  @apply text-lg lg:text-xl font-bold text-center py-4 px-2 bg-primary-gray text-white flex justify-center items-center lg:min-h-[4.5em];\n}\n\n.single_program__body {\n  @apply p-4 lg:p-7 font-bold leading-8 lg:text-lg;\n}\n\n.single_program__more {\n  @apply text-xl font-bold p-10 lg:p-12 text-contrast leading-8;\n}\n\n.confirm_label {\n  @apply whitespace-pre-wrap;\n}\n\n/* .button {\n  @apply cursor-pointer relative inline-block mx-auto border-0 min-w-[280px] text-center py-6 pl-10 pr-10 outline-none transition-all duration-500 ease-in-out overflow-hidden rounded-sm shadow-md hover:shadow-none tracking-widest;\n}\n\n.button_sub {\n  @apply inline-block text-left relative py-4 pl-8 pr-14 rounded-full;\n}\n\n.button_primary {\n  @apply border border-primary-dark text-white bg-gradient-to-tr from-primary-dark to-primary hover:from-primary-dark hover:to-primary-dark;\n} */\n\n@tailwind utilities;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
